// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__cGcp2","unreadBadge":"styles_unreadBadge__31CPA","modalContent":"styles_modalContent__2QBek","modal":"styles_modal__3Sohd"};